import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { take, takeUntil, tap } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

import { FORM_CONFIG as formConfig } from '../labels-f3';
import { ProductosInformacionService } from '../../../core/providers/services/productos-informacion/productos-informacion.service';
import { PaisesListarService } from '../../../core/providers/services/paises-listar/paises-listar.service';
import { UtilsService } from '../../../shared/services/utils/utils.service';
import { ProductIdCorreduria, ProductosInformacionResInterface } from '../../../core/interfaces/producto-informacion.interface';
import { FormPropModel } from '../../../core/models/form-prop.model';
import { CountryListModel } from '../../../core/models/country-list.model';
import { SelectMultipleModel } from '../../../core/models/select-multiple.model';
import { Numbers } from 'src/app/utils/constants';
import { PrefijoPaisesService } from 'src/app/core/providers/services/prefijo-paises/prefijo-paises.service';

@Component({
  selector: 'app-travel-particular',
  templateUrl: './travel-particular.component.html',
  styleUrls: ['./travel-particular.component.scss']
})
export class TravelParticularComponent implements OnInit, OnDestroy {

  /**
   * @description Es el formulario
   */
  @Input() productIdCorreduria: any[];
  @Input() FORM_DATA: FormGroup;

  /**
   * @description Es el formulario
   */
  formConfig: any;
  currentStep = 1;
  modifyStepV = '';
  number100 = 100;
  number17088 = 17088;
  /**
   * @description Subject para finalizar suscripciones
   */
  private finish = new Subject();

  /**
   * @description Es un modelo de datos para el componente de botón
   */
  public dataButton = new FormPropModel({ classes: 'green', label: 'Siguiente' });

  public insuredChoosed: 'Particular' | 'Empresa' = 'Particular';
  /**
   * @description constructor
   * @params productServ
   * @params plSrv
   * @params utSrv
   */
  constructor(
    private productServ: ProductosInformacionService,
    private plSrv: PaisesListarService,
    private utSrv: UtilsService,
    private prefixSrv: PrefijoPaisesService
  ) {
    this.productServ = productServ;
    this.plSrv = plSrv;
    this.utSrv = utSrv;
    this.prefixSrv = prefixSrv;
  }

  newFormConfig: any = {
    ...formConfig
  };
  /**
   * @description Metodo de inicio
   */
  ngOnInit(): void {
    this.newFormConfig.currentStep.pipe(
      take(1)
    ).subscribe(step => {
      this.currentStep = step;
    });
    this.getCurrentStep();
    this.subs();
    this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list = [];
    const listAseg: any[] = [];
    for (let index = 1; index <= Numbers.number100; index++) {
      listAseg.push({ name: `${index}`, id: index });
    }
    this.newFormConfig.numberOfInsured.options.list = listAseg;
    this.newFormConfig.numberOfInsuredList = listAseg;
    // Obtenemos el listado de prefijos telefónicos
    this.prefixSrv.getPrefix()
      .pipe(take(1))
      .subscribe((prefijo) => {
        this.newFormConfig.insuredData.prefix.options.list = prefijo;
        this.newFormConfig.emergencyContact.prefix.options.list = prefijo;
    });
    // Conseguimos todos los productos de limite de garantia: 18.000, 30.000...
    // for (let index = 17084; index <= 17088; index++) {

    if (!(this.productIdCorreduria.length === 1 && this.productIdCorreduria[0] === 0)) {
      this.productIdCorreduria.map(elId => {
        this.listData(elId.producto);
      });
    } else {
      for (let index2 = 17084; index2 <= this.number17088; index2++) {
        this.listData(index2);
      }
      this.listData(Numbers.number17271);
      this.listData(Numbers.number17115);
    }
    this.plSrv.getCountryList()
      .pipe(take(1))
      .subscribe((paisesList: any[]) => {
        // Pais Destino - Multiple
        const countryList: CountryListModel[] = paisesList.map(s => new CountryListModel(s));
        const multipleCountryList: SelectMultipleModel[] = countryList.map(u => new SelectMultipleModel(u));
        // El primer pais es "Seleccionar" por eso lo eliminamos.
        // multipleCountryList.shift();
        this.newFormConfig.countryDestiny.options.multiple = multipleCountryList;
        // Pais Origen - Simple
        const simpleCountryList: any[] = multipleCountryList.map(r => r.value);
        this.newFormConfig.countryOrigin.options.list = simpleCountryList;
        this.newFormConfig.insuredData.country.options.list = simpleCountryList;
        setTimeout(() => {
          this.formConfig = this.newFormConfig;
        }, Numbers.number100);
      });
  }
  /**
   * @description listData
   * @param index2 indice del for
   */
  public listData(index2: any): void {
    this.productServ.getProductInfo(index2)
    .pipe(take(1))
    .subscribe((el: ProductosInformacionResInterface) => {
      el.name = this.utSrv.stringToNumber(el.nombreProducto).toString();
      this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list.push(el);
      this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list =
        this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list.sort((a, b) => a.name - b.name);
    });
  }
  /**
   * @description Metodo de fin
   */
  ngOnDestroy() {
    this.finish.next(true);
  }

  /**
   * @description Cambia el valor del formulario
   */
  private subs(): void {
    if (!this.FORM_DATA) { return; }
    this.FORM_DATA.valueChanges.pipe(
      takeUntil(this.finish),
      tap(el => {
      })
    ).subscribe();
  }

  /**
   * @description Consigue el valor de una propiedad del formulario
   */
  public getCurrentStep(): void {
    this.newFormConfig.currentStep.pipe(
      takeUntil(this.finish)
    ).subscribe(step => {
      this.currentStep = step;
    });
  }

  /**
   * @description Cambio de paso, siguiente o anterior
   */
  public modifyStep(ev: 'back' | 'next'): void {
    if (ev === 'next') {
      this.formConfig.stepIncrement();
    }
    if (ev === 'back') {
      this.formConfig.stepDecrement();
    }

    this.modifyStepV = ev;
  }

  /**
   * @description Cambio de tomador particular o empresa
   */
  changeInsuredType(ev: 'Particular' | 'Empresa'): void {
    this.insuredChoosed = ev;
  }

  /**
   * @description Retorna el tipo de tomador particular o empresa
   */
  getInsuredTypeChoosed(): 'Particular' | 'Empresa' {
    return this.insuredChoosed;
  }


}
